<template>
    <div>
        <!--搜索表单-->
        <div class="search-box">
            <el-form ref="searchForm"  :inline="true" :rules="searchRules" :model="searchForm" >
                     <el-form-item label="操作人编:" prop="adminId">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.adminId" placeholder="请输入操作人编"></el-input>
                    </el-form-item>
                     <el-form-item label="操作人:" prop="adminName">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.adminName" placeholder="请输入操作人"></el-input>
                    </el-form-item>
                     <el-form-item label="学生编号:" prop="studentId">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.studentId" placeholder="请输入学生编号"></el-input>
                    </el-form-item>
                     <el-form-item label="年份:" prop="year">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.year" placeholder="请输入年份"></el-input>
                    </el-form-item>
                     <el-form-item label="报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）:" prop="payImg">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.payImg" placeholder="请输入报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）"></el-input>
                    </el-form-item>
                     <el-form-item label="身份证正:" prop="idCardPositiveImg">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.idCardPositiveImg" placeholder="请输入身份证正"></el-input>
                    </el-form-item>
                     <el-form-item label="身份证反:" prop="idCardSideImg">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.idCardSideImg" placeholder="请输入身份证反"></el-input>
                    </el-form-item>
                     <el-form-item label="成绩扫描:" prop="scoreImg">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.scoreImg" placeholder="请输入成绩扫描"></el-input>
                    </el-form-item>
                     <el-form-item label="成绩类型:" prop="scoreType">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.scoreType" placeholder="请输入成绩类型"></el-input>
                    </el-form-item>
                     <el-form-item label="学籍证明:" prop="studentProofImg">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.studentProofImg" placeholder="请输入学籍证明"></el-input>
                    </el-form-item>
                     <el-form-item label="审核状态:" prop="status">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.status" placeholder="请输入审核状态"></el-input>
                    </el-form-item>
                     <el-form-item label="审核备注:" prop="reason">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.reason" placeholder="请输入审核备注"></el-input>
                    </el-form-item>
                     <el-form-item label="修改时间:" prop="updateTime">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.updateTime" placeholder="请输入修改时间"></el-input>
                    </el-form-item>
                     <el-form-item label="创建时间:" prop="createTime">
                        <el-input size="mini" maxlength="32" show-word-limit  v-model="searchForm.createTime" placeholder="请输入创建时间"></el-input>
                    </el-form-item>
                <el-form-item>
                    <el-button plain size="mini" type="primary" icon="el-icon-search" id="findBtn" v-display:sysStudentExam-find @click="()=>{this.searchForm.pager.page=1;this.submit();}">查询</el-button>
                    <el-button plain size="mini" type="warning" icon="el-icon-refresh" @click="clear">清空</el-button>
                </el-form-item>
            </el-form>
         </div>
         <div style="margin-bottom: 20px;float: right;margin-right: 20px" >
            <el-button plain size="mini" type="success" icon="el-icon-refresh-left" @click="()=>{this.searchForm.pager.page=1;this.submit();}">刷新</el-button>
            <el-button plain size="mini" type="primary" v-display:sysStudentExam-save icon="el-icon-plus" @click="showAddDialog" >新增</el-button>
            <el-dropdown>
                 <el-button type="primary" size="mini" plain style="margin: 0px 10px 0px 10px">
                     批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                 </el-button>
                 <el-dropdown-menu slot="dropdown">
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentExam-batchDelete icon="el-icon-delete" @click="batchDelete" >批量删除</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentExam-leadingIn icon="el-icon-upload" @click="leadingInSysStudentExam">导入</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentExam-export icon="el-icon-download" @click="exportSysStudentExam">导出</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentExam-exportField icon="el-icon-download" @click="exportSysStudentExamDialog">导出选择字段</el-button></el-dropdown-item>
                     <el-dropdown-item><el-button size="mini" type="text" v-display:sysStudentExam-exportModule icon="el-icon-download" @click="exportSysStudentExamModule('upsertForm')">下载模板</el-button></el-dropdown-item>
                 </el-dropdown-menu>
             </el-dropdown>
         </div>
        <!--表格-->
        <el-table border size="mini" class="table-ui" :stripe="true"  :data="tableData" @selection-change="changeFun"  @sort-change="sortChange" >
            <el-table-column type="selection" width="50px" style="text-align: center;margin: auto"></el-table-column>
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <div>
                      <el-form class="upsertForm" :inline="true" label-width="100px">
                         <el-form-item label="操作人编" prop="adminId">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].adminId"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="操作人" prop="adminName">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].adminName"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="学生编号" prop="studentId">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].studentId"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="年份" prop="year">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].year"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）" prop="payImg">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].payImg"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="身份证正" prop="idCardPositiveImg">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].idCardPositiveImg"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="身份证反" prop="idCardSideImg">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].idCardSideImg"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="成绩扫描" prop="scoreImg">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].scoreImg"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="成绩类型" prop="scoreType">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].scoreType"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="学籍证明" prop="studentProofImg">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].studentProofImg"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="审核状态" prop="status">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].status"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="审核备注" prop="reason">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].reason"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="修改时间" prop="updateTime">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].updateTime"  auto-complete="off"></el-input>
                          </el-form-item>
                         <el-form-item label="创建时间" prop="createTime">
                          <el-input readonly size="mini" v-model="tableData[scope.$index].createTime"  auto-complete="off"></el-input>
                          </el-form-item>
                      </el-form>
                    </div>
                </template>
            </el-table-column>
                <el-table-column show-overflow-tooltip prop="adminId" label="操作人编" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="adminName" label="操作人" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="studentId" label="学生编号" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="year" label="年份" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="payImg" label="报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCardPositiveImg" label="身份证正" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="idCardSideImg" label="身份证反" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="scoreImg" label="成绩扫描" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="scoreType" label="成绩类型" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="studentProofImg" label="学籍证明" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="审核状态" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="reason" label="审核备注" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom" ></el-table-column>
            <el-table-column fixed="right" label="操作" width="80"  >
                <template slot-scope="scope">
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><el-button type="text" v-display:sysStudentExam-update @click="showUpdateDialog(scope.row.id)">修改</el-button></el-dropdown-item>
                            <el-dropdown-item><el-button type="text" v-display:sysStudentExam-look @click="toLook($event,scope.row.id)">查看</el-button></el-dropdown-item>
                            <el-dropdown-item><el-button type="text" v-display:sysStudentExam-delete @click="deleteData(scope.row.id)">删除</el-button></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
            <div slot="empty"><no-data></no-data></div>
        </el-table>
        <el-pagination
                style="margin-top: 10px;padding-bottom: 20px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchForm.pager.totalCount"
                :page-size="searchForm.pager.pageSize"
                :current-page.sync="searchForm.pager.page"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                @size-change="sizeChange"
                @current-change="currentChange"
                @prev-click="currentChange"
                @next-click="currentChange"
        ></el-pagination>
        <!--添加或者修改表单-->
        <el-dialog :close-on-click-modal="false" :title="dialog.title"   width="1000px" :visible.sync="dialog.dialogFormVisible">
            <el-form class="upsertForm"  :model="upsertForm" :rules="rules" ref="upsertForm" label-width="100px" :inline="true">
                <input type="hidden" :value="upsertForm.id">
                          <el-form-item label="操作人编" prop="adminId">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.adminId" placeholder="请输入操作人编" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="操作人" prop="adminName">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.adminName" placeholder="请输入操作人" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="学生编号" prop="studentId">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studentId" placeholder="请输入学生编号" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="年份" prop="year">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.year" placeholder="请输入年份" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）" prop="payImg">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.payImg" placeholder="请输入报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="身份证正" prop="idCardPositiveImg">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.idCardPositiveImg" placeholder="请输入身份证正" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="身份证反" prop="idCardSideImg">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.idCardSideImg" placeholder="请输入身份证反" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="成绩扫描" prop="scoreImg">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.scoreImg" placeholder="请输入成绩扫描" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="成绩类型" prop="scoreType">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.scoreType" placeholder="请输入成绩类型" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="学籍证明" prop="studentProofImg">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.studentProofImg" placeholder="请输入学籍证明" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="审核状态" prop="status">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.status" placeholder="请输入审核状态" auto-complete="off"></el-input>
                         </el-form-item>
                          <el-form-item label="审核备注" prop="reason">
                             <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.reason" placeholder="请输入审核备注" auto-complete="off"></el-input>
                         </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini"  @click="dialog.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini"  type="primary" v-if="dialog.title=='增加'" v-display:sysStudentExam-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
                <el-button plain size="mini"  type="primary" v-else v-display:sysStudentExam-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--查看详情-->
        <el-dialog :close-on-click-modal="false" title="查看"   width="1000px" :visible.sync="lookVisible">
            <div>
            <el-form class="upsertForm" :inline="true" label-width="100px">
                       <el-form-item label="操作人编" prop="adminId">
                        <el-input size="mini" v-model="upsertForm.adminId" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="操作人" prop="adminName">
                        <el-input size="mini" v-model="upsertForm.adminName" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="学生编号" prop="studentId">
                        <el-input size="mini" v-model="upsertForm.studentId" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="年份" prop="year">
                        <el-input size="mini" v-model="upsertForm.year" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）" prop="payImg">
                        <el-input size="mini" v-model="upsertForm.payImg" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="身份证正" prop="idCardPositiveImg">
                        <el-input size="mini" v-model="upsertForm.idCardPositiveImg" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="身份证反" prop="idCardSideImg">
                        <el-input size="mini" v-model="upsertForm.idCardSideImg" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="成绩扫描" prop="scoreImg">
                        <el-input size="mini" v-model="upsertForm.scoreImg" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="成绩类型" prop="scoreType">
                        <el-input size="mini" v-model="upsertForm.scoreType" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="学籍证明" prop="studentProofImg">
                        <el-input size="mini" v-model="upsertForm.studentProofImg" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="审核状态" prop="status">
                        <el-input size="mini" v-model="upsertForm.status" readonly auto-complete="off"></el-input>
                        </el-form-item>
                       <el-form-item label="审核备注" prop="reason">
                        <el-input size="mini" v-model="upsertForm.reason" readonly auto-complete="off"></el-input>
                        </el-form-item>
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" class="large" @click="lookVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogExcel.title"   width="650px" :visible.sync="dialogExcel.dialogFormVisible">
            <div v-if="dialogExcel.title=='导入结果'">
            <el-badge :value="cnt" class="item" style="margin: 10px 20px 10px 0px">
                <el-button size="mini">导入总数</el-button>
            </el-badge>
            <el-badge :value="successCnt" class="item" type="primary" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入成功</el-button>
            </el-badge>
            <el-badge :value="errorNumber" class="item" type="warning" style="margin: 10px 20px 10px 10px">
                <el-button size="mini">导入失败</el-button>
            </el-badge>
            <!--表格-->
            <el-table v-show="errorNumber>0" :stripe="true" :data="uploadData" style="margin-top: 10px">
                    <el-table-column prop="adminId" label="操作人编" sortable="custom" ></el-table-column>
                    <el-table-column prop="adminName" label="操作人" sortable="custom" ></el-table-column>
                    <el-table-column prop="studentId" label="学生编号" sortable="custom" ></el-table-column>
                    <el-table-column prop="year" label="年份" sortable="custom" ></el-table-column>
                    <el-table-column prop="payImg" label="报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）" sortable="custom" ></el-table-column>
                    <el-table-column prop="idCardPositiveImg" label="身份证正" sortable="custom" ></el-table-column>
                    <el-table-column prop="idCardSideImg" label="身份证反" sortable="custom" ></el-table-column>
                    <el-table-column prop="scoreImg" label="成绩扫描" sortable="custom" ></el-table-column>
                    <el-table-column prop="scoreType" label="成绩类型" sortable="custom" ></el-table-column>
                    <el-table-column prop="studentProofImg" label="学籍证明" sortable="custom" ></el-table-column>
                    <el-table-column prop="status" label="审核状态" sortable="custom" ></el-table-column>
                    <el-table-column prop="reason" label="审核备注" sortable="custom" ></el-table-column>
                    <el-table-column prop="updateTime" label="修改时间" sortable="custom" ></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" sortable="custom" ></el-table-column>
            </el-table>
        </div>
            <div v-if="dialogExcel.title=='导入'">
                <el-upload class="lead-in-th"
                           style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #4dbd73 ;"
                           :action="uploadUrl"
                           :headers="headers"
                           multiple
                           :show-file-list="false"
                           :on-success="handleSysStudentExamSuccess"
                           :before-upload="beforeSysStudentExamUpload">
                    <div class="" style="width: 440px;height: 50px;">导入</div>
                </el-upload>
                <div class="lead-in-th" @click="exportSysStudentExamModule('upsertForm')" style="border:1px #4dbd73 solid;text-align: center;line-height: 50px;border-radius: 5px;margin-top:30px;color: #fff ;background-color: #51c993">下载模板</div>
            </div>
        </el-dialog>
        <!--选择字段导出-->
        <el-dialog :close-on-click-modal="false"  :title="exportDialogExcel.title"  width="650px" :visible.sync="exportDialogExcel.dialogFormVisible">
           <div style="height: 400px;overflow-y: auto;width: 100%" >
               <!--表格-->
               <el-table border :stripe="true" :data="tableFieldData" style="margin-top: 20px" @selection-change="changeTableFieldFun"  >
                   <el-table-column type="selection" fixed="left" width="40"></el-table-column>
                   <el-table-column prop="key" label="英文字段名" ></el-table-column>
                   <el-table-column prop="name" label="中文字段名" ></el-table-column>
                   <el-table-column prop="newName" label="重命名字段" >
                       <template slot-scope="scope">
                           <el-input  placeholder="重命名字段" maxlength="20" size="mini" v-model="tableFieldData[scope.$index].newName"></el-input>
                       </template>
                   </el-table-column>
               </el-table>
           </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="exportDialogExcel.dialogFormVisible = false">取 消</el-button>
                <el-button plain size="mini" icon="el-icon-download"  type="success" @click="exportSysStudentExamByField">确认导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysStudentExam",
        components: { noData },
        data() {
            return {
                searchForm:{
                      adminId: '',
                      adminName: '',
                      studentId: '',
                      year: '',
                      payImg: '',
                      idCardPositiveImg: '',
                      idCardSideImg: '',
                      scoreImg: '',
                      scoreType: '',
                      studentProofImg: '',
                      status: '',
                      reason: '',
                      updateTime: '',
                      createTime: '',
                    pager:{
                        sortField:'create_time',
                        sortOrder:'desc',
                        page:1,
                        pageSize:10,
                        totalCount:0
                    }
                },
                tableData: [],
                upsertForm:{
                        id:'',
                        adminId:'',
                        adminName:'',
                        studentId:'',
                        year:'',
                        payImg:'',
                        idCardPositiveImg:'',
                        idCardSideImg:'',
                        scoreImg:'',
                        scoreType:'',
                        studentProofImg:'',
                        status:'',
                        reason:'',
                        updateTime:'',
                        createTime:''
                },
                searchRules: {
                          adminId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          year: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          payImg: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCardPositiveImg: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCardSideImg: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          scoreImg: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          scoreType: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentProofImg: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          status: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          reason: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                rules: {
                          adminId: [
                                  { required: true, message: '请输入操作人编', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  { required: true, message: '请输入操作人', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentId: [
                                  { required: true, message: '请输入学生编号', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          year: [
                                  { required: true, message: '请输入年份', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          payImg: [
                                  { required: true, message: '请输入报名费缴费截图（请务必备注“考生姓名”加“身份证后四位”）', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCardPositiveImg: [
                                  { required: true, message: '请输入身份证正', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          idCardSideImg: [
                                  { required: true, message: '请输入身份证反', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          scoreImg: [
                                  { required: true, message: '请输入成绩扫描', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          scoreType: [
                                  { required: true, message: '请输入成绩类型', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          studentProofImg: [
                                  { required: true, message: '请输入学籍证明', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          status: [
                                  { required: true, message: '请输入审核状态', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          reason: [
                                  { required: true, message: '请输入审核备注', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          updateTime: [
                                  { required: true, message: '请输入修改时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                },
                dialog:{
                    dialogFormVisible:false,
                    title:'增加'
                },
                lookVisible:false,
                headers: {
                    token: this.$store.getters.getToken
                },
                rowData: [],
                cnt: '',
                successCnt: '',
                errorNumber: '',
                uploadData: [],
                uploadUrl: `${home}/sysStudentExam/importByExcel`,
                dialogExcel:{
                    dialogFormVisible:false,
                    title:'导入'
                },
                exportDialogExcel:{
                    dialogFormVisible:false,
                    title:'导出选择字段',
                    id:'',
                },
                tableFieldData:[],
                fieldData:[],
                excelParam:{
                    data:'',
                    excelExportList:''
                }
            }
        },
        created(){
            this.$set(this.searchForm,"year", new Date().getFullYear().toString())
        },
        mounted(){
            let findBtn=document.querySelector('#findBtn');
            findBtn&&this.submit();
        },
        methods: {
            changeTableFieldFun(row) {
                this.fieldData = [];
                for (var i = 0; i < row.length; i++) {
                    this.fieldData.push(row[i]);
                }
            },
            changeFun(row) {
                this.rowData = [];
                for (var i = 0; i < row.length; i++) {
                    this.rowData.push(row[i].id);
                }
            },
            sortChange({ column, prop, order }){
                this.searchForm.pager.sortField=prop;
                this.searchForm.pager.sortOrder=order?order.replace(/ending$/,''):'';
                this.submit();
            },
            sizeChange(pageSize){
                this.searchForm.pager.pageSize=pageSize;
                this.submit();
            },
            currentChange(page){
                this.searchForm.pager.page=page;
                this.submit();
            },
            showAddDialog(){
                this.dialog.dialogFormVisible=true;
                this.dialog.title='增加';
                objUtil.setToDefault(this.upsertForm);
                this.$nextTick(()=>{
                    this.$refs.upsertForm.clearValidate();
                });
            },
            showUpdateDialog(id){
                axios({
                    url:`${home}/sysStudentExam/update/findSysStudentExamById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                    this.dialog.dialogFormVisible=true;
                    this.dialog.title = '修改';
                    this.$nextTick(()=>{
                        this.$refs.upsertForm.clearValidate();
                    });
                }).catch(error=>{

                })

            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudentExam/${this.dialog.title==='增加'?'saveSysStudentExam':'update/updateSysStudentExam'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            deleteData(id){
                this.$confirm('删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentExam/deleteSysStudentExam/${id}`,
                        method: 'GET'
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.submit();
                    }).catch(error => {

                    })
                }).catch(() => {

                });

            },
            submit(){
                axios({
                    url:`${home}/sysStudentExam/findSysStudentExamsByCondition`,
                    method:'POST',
                    data:this.searchForm
                }).then(res=>{
                    if(res.data.length===0&&this.searchForm.pager.page>1&&res.totalCount>0){
                        this.searchForm.pager.page--;
                        this.submit();
                    }else{
                        this.tableData=res.data;
                        this.searchForm.pager.totalCount=res.totalCount;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['searchForm'].resetFields();
            },
            toLook($event,id){
                this.lookVisible=true;
                axios({
                    url:`${home}/sysStudentExam/look/lookSysStudentExamById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            },
            leadingInSysStudentExam() {
                this.dialogExcel.dialogFormVisible = true;
                this.dialogExcel.title = '导入';
            },
            exportSysStudentExam() {
                axios({
                    url: `${home}/sysStudentExam/exportSysStudentExam`,
                    method: "POST",
                    data: this.searchForm,
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysStudentExam.xls");
                });
            },
            exportSysStudentExamModule() {
                axios({
                    url: `${home}/sysStudentExam/exportSysStudentExamModule`,
                    method: "GET",
                    responseType: "arraybuffer"
                }).then(res => {
                    fileDownload(res, "sysStudentExam模板.xls");
                });

            },
            handleSysStudentExamSuccess(res, file) {
                this.loading.close();
                this.dialogExcel.dialogUploadVisible = false;
                if (res.result.success== true) {
                    if(res.data.successCnt>0){
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.submit();
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }else{
                        this.cnt = res.data.sumCnt;
                        this.successCnt = res.data.successCnt;
                        this.errorNumber = res.data.errorNumber;
                        this.uploadData = res.data.objectList;
                        this.$message({
                            message: "导入失败",
                            type: "warning"
                        });
                        this.dialogExcel.dialogFormVisible = true;
                        this.dialogExcel.title = '导入结果';
                    }
                } else{
                    this.$message({
                        message: "模板有误或数据为空",
                        type: "error"
                    });
                    this.dialogExcel.dialogUploadErrorVisible = true;
                }
            },
            beforeSysStudentExamUpload(file) {
                this.loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    this.loading.close();
                    this.$message.error("上传模板只能是 xls、xlsx 格式!");
                }
                return extension || extension2;
            },
            batchDelete(){
                if (this.rowData.length <= 0) {
                    this.$message({
                        type: "error",
                        message: "请勾选数据!"
                    });
                    return;
                }
                this.$confirm("确认批量删除吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    axios({
                        url: `${home}/sysStudentExam/batchDeleteSysStudentExam`,
                        method: "post",
                        data: {
                            rowData: this.rowData
                        }
                    }).then(res => {
                        this.$message({
                            type: "success",
                            message: "删除成功!"
                        });
                        this.submit();
                    }).catch(error => {});
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "删除失败!"
                    });
                });
            },
            exportSysStudentExamDialog(){
                axios({
                    url: `${home}/sysStudentExam/getSysStudentExamTableField`,
                    method: "GET",
                }).then(res => {
                    this.tableFieldData = res.data;
                    this.exportDialogExcel.dialogFormVisible = true;
                    this.exportDialogExcel.title = '导出选择字段';
                    this.exportDialogExcel.id = this.id;
                });

            },
            exportSysStudentExamByField() {
                if(this.fieldData.length<=0 ){
                    this.$message({
                        type: "error",
                        message: "请选择需要导出的字段!"
                    });
                }else{
                    this.excelParam.data = this.searchForm;
                    this.excelParam.excelExportList = this.fieldData;
                    axios({
                        url: `${home}/sysStudentExam/exportSysStudentExamByField`,
                        method: "POST",
                        data: this.excelParam,
                        responseType: "arraybuffer"
                    }).then(res => {
                        fileDownload(res, "sysStudentExam.xls");
                    });
                }

            },
        }
    }
</script>
